<template>
    <path d="M19 19h-11l-4 -4a1 1 0 0 1 0 -1.41l10 -10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9 9" />
    <line x1="18" y1="12.3" x2="11.7" y2="6" />
</template>


